import requester from '@/lib/axios';
import { FeedbackCreateDTO } from '@/models/Feedback';
import { WritingQuestion } from '@/models/Question';

const baseUrl = 'writing-activity';
const nestedUrl = (activityId: number) => `activities/${activityId}/${baseUrl}`;

type WritingWritePayload = Partial<Omit<WritingQuestion, 'id' | 'feedbacks'>> & {
  feedbacks?: FeedbackCreateDTO[];
};

export const getWritingQuestion = async (id: number) => {
  const { data: writingActivity } = await requester().get<WritingQuestion>(
    `${baseUrl}/${id}/`,
  );

  return writingActivity;
};

export const updateWritingQuestion = async (
  id: number,
  changes: WritingWritePayload,
) => {
  const { data: writingActivity } = await requester().patch<WritingQuestion>(
    `${baseUrl}/${id}/`,
    changes,
  );

  return writingActivity;
};

export const deleteWritingQuestion = async (id: number) => {
  await requester().delete<WritingQuestion>(`${baseUrl}/${id}/`);
};

export const createWritingQuestion = async (body: WritingWritePayload) => {
  const { data: writingQuestion } = await requester().post<WritingQuestion>(
    `${baseUrl}/`,
    body,
  );

  return writingQuestion;
};

export const createWritingQuestionIntoActivity = async (
  activityId: number,
  body: WritingWritePayload,
) => {
  const { data } = await requester().post<WritingQuestion>(
    `${nestedUrl(activityId)}/`,
    body,
  );
  return data;
};

export const updateWritingQuestionIntoActivity = async (
  activityId: number,
  id: number,
  changes: WritingWritePayload,
) => {
  const { data } = await requester().patch<WritingQuestion>(
    `${nestedUrl(activityId)}/${id}/`,
    changes,
  );
  return data;
};

export const deleteWritingQuestionIntoActivity = async (
  activityId: number,
  id: number,
) => {
  await requester().delete(`${nestedUrl(activityId)}/${id}/`);
};
